import {
    FormElement,
    createFormElement,
    IFormElementBusinessLogic,
} from '@vfde-brix/ws10/form-element';
import { IValidation } from '@vfde-brix/ws10/validation';

/**
 * Returns a Form Element ws10 class mounted on the chosen div
 */
export const mountFormElement = (wrapperId: string, onEnterPress: () => void, validation?: IValidation[]): FormElement | null => {
    const wrapperElement = document.getElementById(wrapperId);
    const business: IFormElementBusinessLogic = {
        onChange: () => { }, // mandatory in brix
        onKeyPress: (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                onEnterPress();
            }
        },
        validation,
    };

    return wrapperElement && createFormElement(wrapperElement, business);
};
